// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  filterAPIKey: 'content-search',
  hostUrl: 'https://apwebsite.xyz',
  localesDirectory: {
    prefix: './assets/i18n/',
    suffix: '.json',
    storageUrl: '',
    apiUrl: 'https://con.apwebsite.xyz/',
  },
  reCaptchaSiteKey: '6LcH574jAAAAAJ4R3_3Ngrp0aloaR89IYo0usInS',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
